import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SearchBySerialComponent } from './search-by-serial/search-by-serial.component'
import { SearchResultComponent } from './search-by-serial/search-result/search-result.component'
import { MatTableModule } from '@angular/material/table'
import { FormsModule } from '@angular/forms'
import { MatSortModule } from '@angular/material/sort'
import { CartModelComponent } from '../../features/welcome-package/search-by-serial/cart-model/cart-model.component'
import { EquipmentDetailsComponent } from '../../features/welcome-package/search-by-serial/equipment-details/equipment-details.component'
import { QuoteModelComponent } from '../../features/welcome-package/search-by-serial/quote-model/quote-model.component'
import { I18nModule, ConfigModule, provideConfig } from '@spartacus/core'
import { DIALOG_TYPE, SpinnerModule } from '@spartacus/storefront'
import { MatTooltipModule } from '@angular/material/tooltip'
import { NgSelectModule } from '@ng-select/ng-select'
import { ScrollContainerModule } from '../../shared/components/scroll-container/scroll-container.module'
import { environment } from '../../../environments/environment'
import { VS_LAUNCH_CALLER } from '../config/dialog.config'
import { DatePickerModule } from '../../shared/components/date-picker/date-picker.module'

@NgModule({
  declarations: [
    SearchBySerialComponent,
    SearchResultComponent,
    EquipmentDetailsComponent,
    CartModelComponent,
    QuoteModelComponent,
  ],
  imports: [
    CommonModule,
    MatTableModule,
    FormsModule,
    MatSortModule,
    MatTooltipModule,
    ScrollContainerModule,
    DatePickerModule,
    SpinnerModule,
    I18nModule,
    NgSelectModule,
    ConfigModule.withConfig({
      i18n: {
        backend: {
          loadPath:
            environment.deployPath + '/assets/i18n-assets/{{lng}}/{{ns}}.json',
        },
        chunks: {
          common: ['welcomePackage'],
        },
      },
    }),
  ],
  exports: [SearchBySerialComponent, MatSortModule],
  providers: [
    provideConfig({
      launch: {
        [VS_LAUNCH_CALLER.CART_MODAL]: {
          inlineRoot: true,
          component: CartModelComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
        [VS_LAUNCH_CALLER.QUOTE_MODAL]: {
          inlineRoot: true,
          component: QuoteModelComponent,
          dialogType: DIALOG_TYPE.DIALOG,
        },
      },
    }),
  ],
})
export class WelcomePackageModule {}
